import styled from 'styled-components';
export var Wrapper = styled.span.withConfig({
  displayName: "PropertyPathstyles__Wrapper",
  componentId: "keen-query-creator__sc-nbychy-0"
})(["&&&{margin:0 3px;display:flex;align-items:center;}"]);
export var Container = styled.span.withConfig({
  displayName: "PropertyPathstyles__Container",
  componentId: "keen-query-creator__sc-nbychy-1"
})(["&&&{display:flex;align-items:center;}"]);